<template>
  <UiField
    class="pb-color-field"
    :class="{
      'pb-color-field-disabled': disabledRef,
    }"
    :label="label"
    :loading="loading"
    :disabled="disabledRef"
    v-bind="$attrs"
  >
    <template #default="{ id }">
      <AutoSpinner>
        <BaseButton
          :id="id"
          :disabled="disabledRef"
          class="pb-color-field-button"
          @click="open"
        >
          <ColorPreview
            class="pb-color-field-button-preview"
            :value="value"
          />
        </BaseButton>
      </AutoSpinner>
    </template>
  </UiField>
  <ColorDialog
    v-bind="control"
    :value="value"
    :loading="loading"
    :disabled="disabledRef"
    @input="inputHandler"
  />
</template>

<script setup>
import { computed } from 'vue'
import { Color } from '@nicolaudie-group/ls-utilities'
import AutoSpinner from '@nicolaudie-group/ng-ui-kit/components/AutoSpinner/AutoSpinner.vue'
import UiField from '@nicolaudie-group/ng-ui-kit/components/UiField/UiField.vue'
import ColorPreview from '@nicolaudie-group/ng-ui-kit/components/Color/ColorPreview.vue'
import BaseButton from '@nicolaudie-group/ng-ui-kit/components/BaseButton/BaseButton.vue'
import ColorDialog from '@/components/ColorDialog/ColorDialog.vue'
import useDialog from '@/composables/useDialog'

defineOptions({
  compatConfig: {
    MODE: 3,
    INSTANCE_LISTENERS: false,
    INSTANCE_ATTRS_CLASS_STYLE: false,
  },
  inheritAttrs: false,
})

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  value: {
    type: [Color, String, Array, Number, Object],
    default: new Color('#ff0000'),
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['input'])

const disabledRef = computed(() => (
  props.disabled || props.loading
))

function inputHandler(value) {
  emit('input', value)
}

const {
  open,
  control,
} = useDialog()
</script>

<style lang="scss" src="./PbColorInput.scss" />
